import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isPnlReportUser } from "./PnLSummary/pnlReportUtils";
import "./reports.css";

export const REPORT_LIST = [
  {
    name: "Carrier Reconciliation Reports",
    icon: "fa fa-exchange",
    path: "/reports/carrier-reconciliation",
  },
  {
    name: "Profit & Loss Summary",
    icon: "fa fa-line-chart",
    path: "/reports/pnl-summary",
    superAdminOnly: true,
  },
];

const ReportsList = () => {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state?.auth?.user);
  const canViewPnl = isPnlReportUser(userDetails?.Value);
  const visibleReports = REPORT_LIST.filter((report) => !report.superAdminOnly || canViewPnl);

  return (
    <main className="reports-list">
      <div className="main__container">
        <div className="main__tile_heading">Reports</div>
        <div className="container-fluid">
          <div className="cus-page-content-sec">
            <div className="content-container">
              <div className="cards setup-container">
                {visibleReports.map((report) => (
                  <button
                    key={report.path}
                    type="button"
                    className="setup-card"
                    onClick={() => navigate(report.path)}
                  >
                    <span className="icon">
                      <i className={report.icon} aria-hidden="true" />
                    </span>
                    <span className="txt-name">{report.name}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ReportsList;
